// Mordomo bilingual dictionary (PT default, EN alternative)
const dict = {
  pt: {
    nav: {
      manifesto: "Manifesto",
      service: "Serviço",
      domains: "Domínios",
      pricing: "Preço",
      enter: "Entrar",
      begin: "Começar",
      logout: "Sair",
    },
    landing: {
      eyebrow: "Mordomo — Serviço de Chief of Staff Pessoal",
      heroTitle: "Não és tu que precisas",
      heroTitleEm: "de fazer mais.",
      heroSub: "És tu que mereces ter mais quem faça por ti.",
      heroBody:
        "Um serviço com dignidade para a Chefe da Casa. Entrega-se via WhatsApp. Ouve-te uma vez, no início. Depois trata. Não pergunta o que precisas — sabe.",
      ctaBegin: "Conhecer o Mordomo",
      ctaLogin: "Já é Chefe",
      atDispor: "Ao seu dispor",
      manifestoTitle: "Há um trabalho que ninguém nomeia.",
      manifestoBody:
        "A Chefe não precisa de mais uma agenda. Precisa de menos peso. São cinquenta micro-decisões por dia — calendário, escola, médicos, prazos, prestadores, datas de família alargada. Somado, é trabalho a tempo inteiro. E recai, desproporcionadamente, sobre a mãe. O Mordomo não te ensina a organizar melhor. Tira-te a carga.",
      manifestoQuote:
        "Outros produtos perguntam «do que precisas?». O Mordomo ouve uma vez, no início, e depois trata.",
      domainsTitle: "Cinco domínios. Um único serviço.",
      domains: {
        logistica: {
          title: "Logística",
          body: "Calendário central com detecção de conflitos. Marcações, confirmações, reagendamentos. Prazos administrativos. Datas-âncora da família alargada.",
        },
        casa: {
          title: "Casa",
          body: "Inventário do que falta. Manutenção. Rituais. Eventos familiares. Coordenação de prestadores. O estado do lar como espaço, não como tarefa.",
        },
        profissional: {
          title: "Reinvenção Profissional",
          body: "A tua identidade para além da maternidade. Upskilling, candidaturas, networking, regresso ao mercado. Reconhece que és mais do que mãe.",
        },
        financas: {
          title: "Finanças Familiares",
          body: "CFO doméstico. Pagamentos, contas, decisões integradas. Multi-moeda, multi-banco, multi-fiscal para vidas em diáspora.",
        },
        educacao: {
          title: "Educação dos Filhos",
          body: "Decisões escolares, percurso, actividades extracurriculares. Apoio em transições — mudança de escola, adaptação cultural se a família muda de país.",
        },
      },
      operatingTitle: "O sistema operativo: Ao Dispor.",
      operatingBody:
        "Não é gatekeeping. Não é espelho. Não é decisão por ti. É execução delegada dentro de um perímetro que tu escolhes. Dentro do perímetro, o Mordomo age sem perguntar. Fora do perímetro, propõe com solução concreta — para que apenas confirmes, não penses a solução.",
      momentsTitle: "Três momentos de uma semana.",
      moments: {
        tue: {
          when: "Terça-feira, 8h",
          title: "O conflito que não chegou a acontecer.",
          body: "«Bom dia. Três coisas tratadas hoje: a Sofia tem dentista às 16h, já confirmei. O João tem natação à mesma hora — combinei com a Joana que leva e traz. A reunião que estava no seu calendário às 16h passei-a para amanhã às 10h. Tem o dia livre entre as 14h e as 17h.»",
        },
        sun: {
          when: "Domingo, 21h",
          title: "A síntese semanal.",
          body: "«Esta semana tratei de 23 itens. Inscrição do João no campo de Verão confirmada — restavam 3 vagas. Renovação do passaporte da Sofia: falta a foto, prazo 30 de Junho. O Tiago perguntou pela hora do almoço de família. Confirmo 13h?»",
        },
        thu: {
          when: "Quinta-feira, 14h30",
          title: "Quando o sistema lê o stress.",
          body: "«Ouvi-a. Trato disto consigo agora. Vou ver se a reunião com a professora pode passar para sexta de manhã e se a avaliação no trabalho pode passar para a próxima semana. Dou-lhe notícias em 30 minutos com proposta concreta. Confia em mim?»",
        },
      },
      pricingTitle: "Premium. Não freemium.",
      pricingBody:
        "O luxo silencioso de ter alguém que se lembra por si. Não é uma app — é o staff que sempre mereceu. A comparação justa não é com apps de produtividade, é com o ginásio premium, o seguro privado, a empregada doméstica. O Mordomo entrega o equivalente a 8–15 horas mensais de trabalho qualificado — pelo preço de um jantar.",
      pricingPromise: "Não pergunta o que precisa. Sabe.",
      planSingle: "Mordomo · ao seu dispor",
      planSingleTag: "Para a Chefe que dirige tudo — e merece staff a sério.",
      planMonth: "por mês",
      planTrial: "26 dias de prova grátis",
      payWithCard: "Pagar com cartão",
      payWithPaypal: "Pagar com PayPal",
      planFeatures: {
        single: [
          "Mordomo de bolso via WhatsApp, 7 dias por semana",
          "Logística doméstica completa — casa, escola, saúde",
          "Memória inviolável — recibos, notas, mensagens e documentos",
          "Casa, agenda e listas sempre em ordem",
          "Finanças sob controlo — orçamentos e despesa por categoria",
          "Educação dos filhos e reinvenção profissional",
          "Briefing matinal e diário semanal",
          "Apoio em emergências — saúde, escola, viagem",
        ],
      },
      whatNotTitle: "O que o Mordomo não é.",
      whatNot: [
        "Não é app de produtividade.",
        "Não é assistente virtual genérico.",
        "Não é serviço terapêutico.",
        "Não é serviço de família. É serviço da Chefe.",
        "Não é caridade. É serviço premium pago.",
      ],
      finalCtaTitle: "Começa em silêncio. Dura em confiança.",
      finalCtaBody: "26 dias de prova grátis. A Chefe escolhe porque merece.",
      finalCtaButton: "Começar 26 dias grátis",
      footer: "Mordomo. Serviço premium para a Chefe da Casa.",
      privacy: "Privacidade",
      terms: "Termos",
      choosePlan: "Começar 26 dias grátis",
      paymentLogin: "Para começar, faça login ou crie conta.",
    },
    auth: {
      loginTitle: "Boa tarde, Chefe.",
      loginSub: "Entre, está em casa.",
      registerTitle: "Comecemos.",
      registerSub: "Ouvirei uma vez. Depois trato.",
      email: "Email",
      password: "Palavra-passe",
      name: "Como prefere ser tratada",
      language: "Língua",
      submitLogin: "Entrar",
      submitRegister: "Criar conta",
      toRegister: "Ainda não tem conta? Comece aqui.",
      toLogin: "Já tem conta? Entre.",
      orLine: "ou",
      demoHint: "Quer apenas ver? Use {email} · {password}",
      consentLeadIn: "Li e aceito os",
      consentTerms: "Termos",
      consentAnd: "e a",
      consentPrivacy: "Política de Privacidade",
    },
    onboarding: {
      title: "Vamos definir o perímetro.",
      sub: "Cinco perguntas. Depois o Mordomo trata.",
      stepOf: "Passo {n} de 5",
      q1Title: "Como prefere que a trate?",
      q1Sub: "A linguagem é psicologia. O tom escolhido importa em cada interacção.",
      toneTu: "Por «tu», com calor contido",
      toneVoce: "Por «você», com formalidade respeitosa",
      toneYou: "By «you», warm and contained",
      q2Title: "Quem está na vida da Chefe?",
      q2Sub: "Família próxima e alargada, como contexto. Não é cliente. Apenas contexto.",
      familyPlaceholder: "Ex.: Casada com o Tiago. Pais em Lisboa, sogros no Porto. Marido viaja...",
      childrenPlaceholder: "Ex.: Sofia, 11. João, 8. Pedro, 6.",
      q3Title: "O que pode o Mordomo fazer sem pedir autorização?",
      q3Sub: "Por omissão, o perímetro é médio-pragmático. Pode ajustar.",
      perimeterPlaceholder: "Ex.: Pode marcar consultas, lembrar prazos, responder à escola em contextos pré-autorizados, pagar contas até 300€/mês...",
      q4Title: "Quando prefere o resumo semanal?",
      q4Sub: "Síntese de tudo o que foi tratado. Por omissão, domingo à noite.",
      sunday: "Domingo",
      monday: "Segunda",
      friday: "Sexta",
      saturday: "Sábado",
      q5Title: "Modo de operação inicial.",
      q5Sub: "Durante os primeiros meses, o Mordomo pode anunciar cada acção (verbose) ou agir em silêncio e sintetizar no resumo. Pode mudar a qualquer momento.",
      verbose: "Verbose — anuncia cada acção",
      silent: "Silencioso — síntese semanal",
      next: "Seguir",
      back: "Voltar",
      finish: "Concluir onboarding",
      finishing: "A acomodar tudo...",
      familyLabel: "Família e contexto",
      childrenLabel: "Filhos",
      welcomeNote: "«Ouvi-te. Trato a partir de agora.»",
    },
    app: {
      good_morning: "Bom dia",
      good_afternoon: "Boa tarde",
      good_evening: "Boa noite",
      this_week: "Esta semana",
      total_items: "Itens em curso",
      done: "Concluídos",
      needs_auth: "À sua autorização",
      hours_saved: "Horas recuperadas",
      activity: "Actividade",
      this_week_summary: "Esta semana",
      diary: "Diário do Mordomo",
      domains_tab: "Domínios",
      addItem: "Adicionar item",
      tabActive: "Em curso",
      tabAuth: "À sua autorização",
      tabDone: "Concluídos",
      authorise: "Autorizar",
      markDone: "Marcar concluído",
      noActive: "Nada em curso. Está tudo em silêncio — como deve ser.",
      noAuth: "Nada à sua autorização.",
      noDone: "Ainda não há itens concluídos esta semana.",
      domainLabels: {
        logistica: "Logística",
        casa: "Casa",
        profissional: "Profissional",
        financas: "Finanças",
        educacao: "Educação",
      },
      newItem: "Novo item",
      newItemTitle: "O que precisa de ser tratado?",
      title: "Título",
      details: "Detalhes (opcional)",
      domain: "Domínio",
      create: "Criar",
      cancel: "Cancelar",
      sidebar: {
        dashboard: "Hoje",
        chat: "Conversa",
        diary: "Diário",
        settings: "Definições",
      },
      chat: {
        title: "Conversa com o Mordomo",
        placeholder: "Escreva uma mensagem...",
        send: "Enviar",
        empty: "Sem mensagens. Pode começar quando quiser.",
        thinking: "A pensar...",
        errorCta: {
          subscribe: "Subscrever agora",
          loading: "A abrir checkout…",
        },
      },
      diaryHeader: "Diário do Mordomo",
      diaryIntro:
        "Memória da sua vida em três níveis. Semanal, mensal, anual. Confidencial, por construção. Não alimenta modelos, não sai da sua conta.",
      diarySoon: "Síntese mensal disponível no fim do mês.",
      welcome_first_name: "Bem-vinda",
      snapshotCreate: "Gerar síntese",
      snapshotGenerating: "A acomodar memória…",
      snapshotEmpty: "Sem sínteses ainda. Gere a primeira ao fim da semana.",
      snapshotWeekly: "Semanal",
      snapshotMonthly: "Mensal",
      snapshotHistory: "Sínteses anteriores",
      paid: "Onboarding pago",
      payNow: "Pagar onboarding",
      paymentSuccessTitle: "Está em casa.",
      paymentSuccessBody: "O seu onboarding está pago. O Mordomo aguarda.",
      paymentPendingTitle: "A confirmar o pagamento…",
      paymentPendingBody: "Recebemos. Damos notícias num instante.",
      paymentCancelTitle: "Sem pressa.",
      paymentCancelBody: "O pagamento foi cancelado. Quando quiser, volte ao plano que escolheu.",
      paymentBack: "Voltar à página principal",
      paymentToApp: "Entrar na conta",
      briefingTitle: "Briefing de hoje",
      briefingGenerating: "A escrever o briefing…",
      briefingRefresh: "Gerar de novo",
      trialBanner: {
        labelTrial: "— Prova grátis",
        labelGrace: "— Atenção",
        labelEnded: "— Subscrição",
        endsToday: "A sua prova termina hoje.",
        endsTomorrow: "A sua prova termina amanhã.",
        endsInDays: "A sua prova termina em {n} dias.",
        endsInDay: "A sua prova termina em {n} dia.",
        afterTrial: "No fim da prova, escolha um plano quando quiser continuar. Sem cobranças automáticas.",
        pastDue: "Há uma cobrança em falha. Atualize o método de pagamento para não perder o serviço.",
        cancelled: "A sua subscrição foi cancelada. Pode retomar quando entender.",
        expired: "A sua subscrição terminou.",
        ctaManage: "Gerir subscrição",
        ctaUpdate: "Atualizar cartão",
      },
      sidebar2: {
        calendar: "Calendário",
        ingest: "Ingestão",
        proposals: "Propostas",
        shopping: "Compras",
        recipes: "Receitas",
        family: "Família",
        agreements: "Acordos",
        appointments: "Consultas",
        medications: "Medicação",
        memory: "Memória",
        connectGmail: "Caixa de correio",
      },
      agreements: {
        tag: "Acordos digitais",
        title: "Acordos digitais com os filhos.",
        sub: "Os limites de ecrã saem da boca da mãe e passam a viver num pacto silencioso. O Mordomo lembra, anota, e fala consigo no fim do dia.",
        newBtn: "Novo acordo",
        newTitle: "Novo acordo",
        editTitle: "Editar acordo",
        formIntro: "Os termos que combinámos.",
        noChildren: "Adicione primeiro os seus filhos em «Família», depois marcamos os acordos.",
        childEmpty: "Sem acordos para este filho. Comece pelo mais sensível.",
        yearsOld: "anos",
        childLabel: "Filho(a)",
        appLabel: "Aplicação ou categoria",
        dailyLimitLabel: "Limite diário (min)",
        windowStartLabel: "Janela inicia (HH:MM)",
        windowEndLabel: "Termina às",
        weekendLimitLabel: "Limite fim-de-semana (min)",
        consequenceLabel: "Se quebrar o acordo",
        perDay: "por dia",
        startsAt: "desde",
        endsAt: "até",
        weekend: "fim-de-semana",
        noLimits: "Sem limites definidos",
        edit: "Editar",
        notify: "Convidar a assinar",
        notifyAgain: "Reenviar convite",
        notifySent: "Convite enviado. Aguardo resposta do filho.",
        notifyFailed: "O WhatsApp não confirmou o envio. Tente daqui a um momento.",
        noPhoneHint: "Adicione o WhatsApp do filho em «Família».",
        deactivate: "Desactivar",
        activate: "Activar",
        delete: "Apagar",
        deleteConfirm: "Apagar este acordo? O histórico também desaparece.",
        cancel: "Cancelar",
        save: "Guardar",
        create: "Combinar",
        signedOn: "Assinado em",
        talkRequested: "O filho pediu para conversar antes de aceitar.",
        status: {
          signed: "Assinado",
          talk: "Quer conversar",
          sent: "Convite enviado",
          draft: "Por convidar",
        },
      },
      connectGmail: {
        tag: "Caixa de correio",
        title: "O Mordomo abre o correio da Chefe.",
        sub: "Manhãs sem inbox. O Mordomo lê durante a noite, separa o urgente do ruído, e às oito e meia traz um resumo de cinco linhas. As respostas escrevem-se em três toques.",
        active: "Activa",
        connectedAt: "Ligada desde {when}",
        connectedFlash: "Está feito. Acabei de me apresentar à sua caixa de {email}. A primeira triagem chega amanhã de manhã.",
        cta: "Conectar a minha caixa de correio",
        disconnect: "Desligar caixa de correio",
        disconnectConfirm: "Desligar e apagar tokens?",
        privacy: "Os tokens ficam encriptados (AES, Fernet). O Mordomo lê apenas o necessário para fazer a triagem e rascunhar respostas. Nada é enviado sem a sua confirmação. Pode desligar a qualquer momento — apaga-se tudo.",
        promises: [
          "Triagem diária às 08:30 via WhatsApp",
          "Rascunhos de resposta no seu tom — só envia com a sua aprovação",
          "Recibos em anexo passam directamente para a Memória",
          "Convites de calendário são criados automaticamente",
          "Desligar elimina todos os tokens no momento",
        ],
        triageTitle: "Triagem da caixa",
        triageBtn: "Triar agora",
        triaging: "A triar…",
        triageEmpty: "Ainda sem triagem. Toque «Triar agora» e eu trato.",
        draftBtn: "Redigir resposta",
        drafting: "A escrever…",
        draftPlaceholder: "O rascunho do Mordomo aparece aqui…",
        sendBtn: "Enviar",
        sending: "A enviar…",
        archiveBtn: "Arquivar",
        archiving: "A arquivar…",
        cancelBtn: "Cancelar",
        sentLabel: "✓ Enviado",
        archivedLabel: "Arquivado",
        briefingTitle: "Briefing matinal",
        briefingPreview: "Pré-visualizar briefing",
        briefingSend: "Enviar para WhatsApp",
        briefingSending: "A enviar…",
        briefingSent: "Briefing enviado para o WhatsApp.",
        briefingEmpty: "Nada novo desde a última triagem.",
        briefingNoWhatsapp: "Para receber no WhatsApp, adicione o seu número no perfil.",
        wrapupTitle: "Fecho do dia",
        wrapupPreview: "Pré-visualizar fecho",
        wrapupSend: "Enviar para WhatsApp",
        wrapupSent: "Fecho enviado para o WhatsApp.",
        wrapupNoActivity: "Hoje não houve actividade na caixa.",
      },
      memory: {
        title: "Memória",
        sub: "O Mordomo guarda. A Chefe esquece.",
        tabAll: "Tudo",
        tabExpenses: "Despesas",
        tabAsk: "Perguntar",
        captureBtn: "+ Arquivar",
        captureModalTitle: "Arquivar um momento",
        captureModalSub: "Tira a foto, manda um áudio, ou escreve. Eu trato do resto.",
        capturePhoto: "Fotografia",
        captureAudio: "Áudio",
        captureText: "Texto",
        captureTextPlaceholder: "Uma nota, recibo escrito, lembrete…",
        captureSubmit: "Arquivar",
        capturing: "A arquivar…",
        empty: "Nada arquivado ainda. Comece pelo primeiro documento.",
        searchPlaceholder: "Procurar no arquivo…",
        filterType: "Tipo",
        filterCategory: "Categoria",
        filterMonth: "Mês",
        filterAll: "Todos",
        docTypes: {
          receipt: "Recibo",
          invoice: "Fatura",
          handwritten_note: "Nota",
          message_screenshot: "Mensagem",
          school_document: "Escola",
          medical_document: "Médico",
          id_document: "Identificação",
          other: "Outro",
        },
        categories: {
          mercado: "Mercearia",
          saude: "Saúde",
          educacao: "Educação",
          casa: "Casa",
          transportes: "Transportes",
          lazer: "Lazer",
          vestuario: "Vestuário",
          restauracao: "Restauração",
          servicos: "Serviços",
          subscricoes: "Subscrições",
          viagens: "Viagens",
          outros: "Outros",
        },
        expensesThisMonth: "Este mês",
        expensesPrevMonth: "Mês anterior",
        expensesByCategory: "Por categoria",
        expensesTrend: "Últimos 6 meses",
        expensesEmpty: "Quando arquivar recibos, ver-se-á tudo aqui.",
        recent: "Recentes",
        askPlaceholder: "Mordomo, quanto gastei em pediatria este ano?",
        askBtn: "Perguntar",
        asking: "A consultar…",
        deleteBtn: "Apagar",
        deleteConfirm: "Apagar esta memória?",
        capturedAt: "Documento de",
        archivedAt: "Arquivado",
        sourceTypes: { image: "Foto", audio: "Áudio", text: "Texto" },
      },
      ingestTitle: "Ingestão",
      ingestSub: "Cole um email, uma mensagem de grupo, ou carregue uma fotografia. O Mordomo lê e propõe.",
      ingestTextLabel: "Texto",
      ingestTextPlaceholder: "Cole o email, screenshot ou mensagem aqui…",
      ingestImageLabel: "Imagem",
      ingestImageHint: "PNG ou JPG. Cartazes, screenshots, agendas em foto.",
      ingestImagePasteHint: "Pode também colar (Ctrl/Cmd+V) uma imagem do ecrã.",
      ingestImagePasted: "Colada",
      openChat: "Abrir conversa",
      ingestAudioLabel: "Áudio",
      ingestAudioHint: "Carregue para gravar ou parar.",
      ingestRecord: "Gravar",
      ingestStop: "Parar",
      ingestProcess: "Processar",
      ingestProcessing: "A ler…",
      ingestResult: "Resultado",
      ingestEvents: "compromissos",
      ingestTasks: "tarefas",
      ingestShopping: "compras",
      ingestSeeProposals: "Ver propostas",
      proposalsTitle: "À sua autorização",
      proposalsSub: "Propostas extraídas dos seus emails, fotos e áudio. Aprove para entrarem nos seus domínios.",
      proposalsEmpty: "Sem propostas pendentes.",
      proposalsApprove: "Aprovar",
      proposalsDecline: "Recusar",
      proposalsSource: "Origem",
      kindEvent: "Compromisso",
      kindTask: "Tarefa",
      kindShopping: "Item de compras",
      calendarTitle: "Calendário",
      calendarSub: "Vista da semana. Detecta conflitos automaticamente. Subscrevível em Google, Apple, Outlook.",
      calendarToday: "Hoje",
      calendarPrev: "Semana anterior",
      calendarNext: "Semana seguinte",
      calendarAdd: "Novo evento",
      calendarIcal: "Exportar iCal",
      calendarConflicts: "Conflitos",
      calendarNoEvents: "Sem eventos esta semana.",
      eventTitle: "Título",
      eventStart: "Início",
      eventEnd: "Fim",
      eventLocation: "Local",
      eventNotes: "Notas",
      eventCreate: "Criar evento",
      shoppingTitle: "Compras",
      shoppingSub: "Listas e receitas. As receitas geram lista automaticamente.",
      shoppingNewList: "Nova lista",
      shoppingListName: "Nome da lista",
      shoppingAddItem: "Adicionar item",
      shoppingEmptyLists: "Sem listas. Crie a primeira.",
      shoppingPending: "por comprar",
      recipesTitle: "Receitas",
      recipesNew: "Nova receita",
      recipesName: "Nome",
      recipesIngredients: "Ingredientes (um por linha)",
      recipesSteps: "Modo de preparação (opcional)",
      recipesToShopping: "Enviar para compras",
      recipesEmpty: "Sem receitas. Adicione a primeira.",
      familyTitle: "Família",
      familySub: "Contexto da Chefe. Membros próximos e alargados. Não são clientes — são contexto.",
      familyNew: "Adicionar membro",
      familyName: "Nome",
      familyRole: "Papel",
      familyAge: "Idade",
      familyNotes: "Notas",
      familyPhone: "WhatsApp (E.164, opcional)",
      familyRoles: {
        spouse: "Cônjuge",
        child: "Filho/Filha",
        parent: "Pai/Mãe",
        in_law: "Sogro/Sogra",
        sibling: "Irmão/Irmã",
        other: "Outro",
      },
      familyEmpty: "Sem membros registados.",
      appointments: {
        title: "Consultas",
        sub: "O registo das consultas médicas da família. Privado, reservado ao Mordomo — não entra em resumos partilhados.",
        loading: "A consultar…",
        empty: "Ainda não há consultas marcadas.",
        activeHeader: "Marcadas",
        cancelledHeader: "Canceladas",
        includeInactive: "Mostrar canceladas",
        whenLabel: "Quando",
        locationLabel: "Local",
        providerLabel: "Médico",
        viaChatHint: "Para marcar, alterar ou cancelar, fala com o Mordomo no chat.",
      },
      medications: {
        title: "Medicação",
        sub: "O registo das medicações da família. Privado, reservado ao Mordomo — não entra em resumos partilhados.",
        loading: "A consultar…",
        empty: "Ainda não há medicações registadas.",
        activeHeader: "Em curso",
        cancelledHeader: "Canceladas",
        includeInactive: "Mostrar canceladas",
        timesLabel: "Horários",
        weekdaysLabel: "Dias",
        periodLabel: "Período",
        ongoing: "Em curso",
        startsOn: "Começa",
        endsOn: "Termina",
        everyDay: "Todos os dias",
        weekdayShort: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
        viaChatHint: "Para adicionar, alterar ou cancelar, fala com o Mordomo no chat.",
      },
      emergencyButton: "Emergência",
      emergencyTitle: "Escalada",
      emergencySub: "O Mordomo escuta e mobiliza-se já. Diga apenas o essencial.",
      emergencyCategory: "Categoria",
      emergencyCategories: {
        medical: "Médica",
        school: "Escolar",
        emotional: "Emocional",
        other: "Outra",
      },
      emergencyDescription: "Descrição",
      emergencySend: "Pedir escalada",
      emergencySent: "Escalada registada",
      voice: "Voz",
      voiceRecording: "A gravar…",
      voiceProcessing: "A transcrever…",
    },
  },
  en: {
    nav: {
      manifesto: "Manifesto",
      service: "Service",
      domains: "Domains",
      pricing: "Pricing",
      enter: "Sign in",
      begin: "Begin",
      logout: "Sign out",
    },
    landing: {
      eyebrow: "Mordomo — Personal Chief of Staff Service",
      heroTitle: "You don't need",
      heroTitleEm: "to do more.",
      heroSub: "You deserve to have more people doing things for you.",
      heroBody:
        "A service of dignity for the Chefe of the House. Delivered via WhatsApp. Listens to you once, at the start. Then handles it. Never asks what you need — knows.",
      ctaBegin: "Meet the Mordomo",
      ctaLogin: "Already a Chefe",
      atDispor: "At your service",
      manifestoTitle: "There is a labour no one names.",
      manifestoBody:
        "The Chefe doesn't need another agenda. She needs less weight. Fifty micro-decisions a day — calendar, school, doctors, deadlines, providers, extended family dates. Added up, it's full-time work. And it falls, disproportionately, on the mother. The Mordomo doesn't teach you to organise better. It takes the load away.",
      manifestoQuote:
        "Other products ask «what do you need?». The Mordomo listens once, in onboarding, and then handles.",
      domainsTitle: "Five domains. One service.",
      domains: {
        logistica: {
          title: "Logistics",
          body: "Central calendar with conflict detection. Bookings, confirmations, rescheduling. Administrative deadlines. Anchor dates of extended family.",
        },
        casa: {
          title: "Home",
          body: "Inventory of what's missing. Maintenance. Rituals. Family events. Coordination of providers. The state of the home as a space, not a task.",
        },
        profissional: {
          title: "Professional Reinvention",
          body: "Your identity beyond motherhood. Upskilling, applications, networking, return to market. Recognises that you are more than mother.",
        },
        financas: {
          title: "Family Finances",
          body: "Household CFO. Payments, bills, integrated decisions. Multi-currency, multi-bank, multi-fiscal for diaspora lives.",
        },
        educacao: {
          title: "Children's Education",
          body: "Schooling decisions, paths, extracurriculars. Support in transitions — school changes, cultural adaptation if the family relocates.",
        },
      },
      operatingTitle: "The operating system: At your service.",
      operatingBody:
        "Not gatekeeping. Not a mirror. Not deciding for you. It's delegated execution within a perimeter that you choose. Inside the perimeter, the Mordomo acts without asking. Outside the perimeter, it proposes with a concrete solution — so that you only confirm, not solve.",
      momentsTitle: "Three moments of one week.",
      moments: {
        tue: {
          when: "Tuesday, 8am",
          title: "The conflict that never arrived.",
          body: "«Good morning. Three things handled today: Sofia has the dentist at 4pm, confirmed. João has swimming at the same time — arranged with Joana to take and bring him. The meeting that was on your calendar at 4pm I moved to tomorrow at 10am. Your day is free between 2pm and 5pm.»",
        },
        sun: {
          when: "Sunday, 9pm",
          title: "The weekly synthesis.",
          body: "«This week I handled 23 items. João's summer camp registration confirmed — 3 places remained. Sofia's passport renewal: photo still missing, deadline 30 June. Tiago asked about the family lunch time. Shall I confirm 1pm?»",
        },
        thu: {
          when: "Thursday, 2:30pm",
          title: "When the system reads stress.",
          body: "«I heard you. I'll handle this with you now. I'll check if the meeting with the teacher can move to Friday morning and if the review at work can move to next week. I'll bring you news in 30 minutes with a concrete proposal. Trust me?»",
        },
      },
      pricingTitle: "Premium. Not freemium.",
      pricingBody:
        "The silent luxury of someone who remembers for you. Not an app — the staff you've always deserved. The fair comparison is not with productivity apps, it's with the premium gym, the private health insurance, the housekeeper. The Mordomo delivers the equivalent of 8–15 monthly hours of qualified work — for the price of one dinner.",
      pricingPromise: "Never asks what you need. Knows.",
      planSingle: "Mordomo · at your service",
      planSingleTag: "For the Chefe who runs everything — and deserves real staff.",
      planMonth: "per month",
      planTrial: "26-day free trial",
      payWithCard: "Pay with card",
      payWithPaypal: "Pay with PayPal",
      planFeatures: {
        single: [
          "Pocket butler via WhatsApp, 7 days a week",
          "Full household logistics — home, school, health",
          "Untouchable archive — receipts, notes, messages, documents",
          "Home, agenda and lists always in order",
          "Finances under control — budgets and spend by category",
          "Children's education and professional reinvention",
          "Morning briefing and weekly diary",
          "Emergency support — health, school, travel",
        ],
      },
      whatNotTitle: "What the Mordomo is not.",
      whatNot: [
        "Not a productivity app.",
        "Not a generic virtual assistant.",
        "Not a therapeutic service.",
        "Not a family service. It serves the Chefe.",
        "Not charity. It is a paid premium service.",
      ],
      finalCtaTitle: "Begins in silence. Lasts in trust.",
      finalCtaBody: "26-day free trial. The Chefe chooses because she deserves it.",
      finalCtaButton: "Start 26-day trial",
      footer: "Mordomo. Premium service for the Chefe of the house.",
      privacy: "Privacy",
      terms: "Terms",
      choosePlan: "Start 26-day trial",
      paymentLogin: "To begin, sign in or create an account.",
    },
    auth: {
      loginTitle: "Good afternoon, Chefe.",
      loginSub: "Come in, you are home.",
      registerTitle: "Let's begin.",
      registerSub: "I shall listen once. Then handle.",
      email: "Email",
      password: "Password",
      name: "How you prefer to be addressed",
      language: "Language",
      submitLogin: "Sign in",
      submitRegister: "Create account",
      toRegister: "No account yet? Begin here.",
      toLogin: "Have an account? Sign in.",
      orLine: "or",
      demoHint: "Just looking? Use {email} · {password}",
      consentLeadIn: "I have read and accept the",
      consentTerms: "Terms",
      consentAnd: "and the",
      consentPrivacy: "Privacy Policy",
    },
    onboarding: {
      title: "Let us define the perimeter.",
      sub: "Five questions. Then the Mordomo handles.",
      stepOf: "Step {n} of 5",
      q1Title: "How do you prefer to be addressed?",
      q1Sub: "Language is psychology. Tone matters in every interaction.",
      toneTu: "By «tu», warm and contained",
      toneVoce: "By «você», respectful formality",
      toneYou: "By «you», warm and contained",
      q2Title: "Who is in the Chefe's life?",
      q2Sub: "Close and extended family, as context. Not the client. Just context.",
      familyPlaceholder: "Ex.: Married to Tiago. Parents in Lisbon, in-laws in Porto. Husband travels...",
      childrenPlaceholder: "Ex.: Sofia, 11. João, 8. Pedro, 6.",
      q3Title: "What may the Mordomo do without asking?",
      q3Sub: "By default, the perimeter is medium-pragmatic. You may adjust.",
      perimeterPlaceholder: "Ex.: May book appointments, remind deadlines, reply to school in pre-authorised contexts, pay recurring bills up to €300/month...",
      q4Title: "When do you prefer the weekly summary?",
      q4Sub: "Synthesis of all that was handled. By default, Sunday night.",
      sunday: "Sunday",
      monday: "Monday",
      friday: "Friday",
      saturday: "Saturday",
      q5Title: "Initial operating mode.",
      q5Sub: "During the first months, the Mordomo may announce every action (verbose) or act in silence and synthesise in the summary. You may change at any time.",
      verbose: "Verbose — announce every action",
      silent: "Silent — weekly synthesis",
      next: "Continue",
      back: "Back",
      finish: "Complete onboarding",
      finishing: "Settling everything in...",
      familyLabel: "Family and context",
      childrenLabel: "Children",
      welcomeNote: "«I heard you. From here I handle.»",
    },
    app: {
      good_morning: "Good morning",
      good_afternoon: "Good afternoon",
      good_evening: "Good evening",
      this_week: "This week",
      total_items: "Items in progress",
      done: "Done",
      needs_auth: "Awaiting your authorisation",
      hours_saved: "Hours recovered",
      activity: "Activity",
      this_week_summary: "This week",
      diary: "Mordomo's Diary",
      domains_tab: "Domains",
      addItem: "Add item",
      tabActive: "In progress",
      tabAuth: "Awaiting authorisation",
      tabDone: "Done",
      authorise: "Authorise",
      markDone: "Mark done",
      noActive: "Nothing in progress. All quiet — as it should be.",
      noAuth: "Nothing awaiting your authorisation.",
      noDone: "No items completed this week yet.",
      domainLabels: {
        logistica: "Logistics",
        casa: "Home",
        profissional: "Professional",
        financas: "Finances",
        educacao: "Education",
      },
      newItem: "New item",
      newItemTitle: "What needs to be handled?",
      title: "Title",
      details: "Details (optional)",
      domain: "Domain",
      create: "Create",
      cancel: "Cancel",
      sidebar: {
        dashboard: "Today",
        chat: "Conversation",
        diary: "Diary",
        settings: "Settings",
      },
      chat: {
        title: "Conversation with the Mordomo",
        placeholder: "Type a message...",
        send: "Send",
        empty: "No messages. Begin whenever you wish.",
        thinking: "Thinking...",
        errorCta: {
          subscribe: "Subscribe now",
          loading: "Opening checkout…",
        },
      },
      diaryHeader: "Mordomo's Diary",
      diaryIntro:
        "Memory of your life in three levels. Weekly, monthly, annual. Confidential by construction. Does not feed models, does not leave your account.",
      diarySoon: "Monthly synthesis available at the end of the month.",
      welcome_first_name: "Welcome",
      snapshotCreate: "Generate synthesis",
      snapshotGenerating: "Settling memory…",
      snapshotEmpty: "No syntheses yet. Generate the first at week's end.",
      snapshotWeekly: "Weekly",
      snapshotMonthly: "Monthly",
      snapshotHistory: "Previous syntheses",
      paid: "Onboarding paid",
      payNow: "Pay onboarding",
      paymentSuccessTitle: "You are home.",
      paymentSuccessBody: "Your onboarding is paid. The Mordomo awaits.",
      paymentPendingTitle: "Confirming payment…",
      paymentPendingBody: "Received. We'll bring you news in a moment.",
      paymentCancelTitle: "No rush.",
      paymentCancelBody: "Payment was cancelled. When you wish, return to the plan you chose.",
      paymentBack: "Back to main page",
      paymentToApp: "Enter the account",
      briefingTitle: "Today's briefing",
      briefingGenerating: "Writing the briefing…",
      briefingRefresh: "Regenerate",
      trialBanner: {
        labelTrial: "— Free trial",
        labelGrace: "— Attention",
        labelEnded: "— Subscription",
        endsToday: "Your trial ends today.",
        endsTomorrow: "Your trial ends tomorrow.",
        endsInDays: "Your trial ends in {n} days.",
        endsInDay: "Your trial ends in {n} day.",
        afterTrial: "When the trial ends, choose a plan whenever you wish to continue. No automatic charges.",
        pastDue: "A payment failed. Update your card to keep the service.",
        cancelled: "Your subscription was cancelled. You can resume at any time.",
        expired: "Your subscription has ended.",
        ctaManage: "Manage subscription",
        ctaUpdate: "Update card",
      },
      sidebar2: {
        calendar: "Calendar",
        ingest: "Ingest",
        proposals: "Proposals",
        shopping: "Shopping",
        recipes: "Recipes",
        family: "Family",
        agreements: "Pacts",
        appointments: "Appointments",
        medications: "Medication",
        memory: "Memory",
        connectGmail: "Inbox",
      },
      agreements: {
        tag: "Digital pacts",
        title: "Digital pacts with the children.",
        sub: "Screen-time limits leave the mother's mouth and live in a quiet pact. The Mordomo remembers, notes, and reports at the end of the day.",
        newBtn: "New pact",
        newTitle: "New pact",
        editTitle: "Edit pact",
        formIntro: "The terms we agreed.",
        noChildren: "First add your children in «Family», then we set the pacts.",
        childEmpty: "No pacts for this child yet. Start with the most sensitive one.",
        yearsOld: "years old",
        childLabel: "Child",
        appLabel: "App or category",
        dailyLimitLabel: "Daily limit (min)",
        windowStartLabel: "Window starts (HH:MM)",
        windowEndLabel: "Ends at",
        weekendLimitLabel: "Weekend limit (min)",
        consequenceLabel: "If broken",
        perDay: "per day",
        startsAt: "from",
        endsAt: "until",
        weekend: "weekend",
        noLimits: "No limits defined",
        edit: "Edit",
        notify: "Invite to sign",
        notifyAgain: "Resend invite",
        notifySent: "Invite sent. Waiting for the child to answer.",
        notifyFailed: "WhatsApp did not confirm. Please try again shortly.",
        noPhoneHint: "Add the child's WhatsApp number in «Family».",
        deactivate: "Deactivate",
        activate: "Activate",
        delete: "Delete",
        deleteConfirm: "Delete this pact? History will also be removed.",
        cancel: "Cancel",
        save: "Save",
        create: "Agree",
        signedOn: "Signed on",
        talkRequested: "The child asked to talk before accepting.",
        status: {
          signed: "Signed",
          talk: "Wants to talk",
          sent: "Invite sent",
          draft: "Not invited",
        },
      },
      connectGmail: {
        tag: "Inbox",
        title: "The Mordomo opens the Chefe's mail.",
        sub: "Mornings without an inbox. The Mordomo reads overnight, separates urgent from noise, and at half past eight brings a five-line summary. Replies take three taps.",
        active: "Active",
        connectedAt: "Connected since {when}",
        connectedFlash: "It is done. I have just introduced myself to your {email} inbox. The first triage arrives tomorrow morning.",
        cta: "Connect my inbox",
        disconnect: "Disconnect inbox",
        disconnectConfirm: "Disconnect and delete tokens?",
        privacy: "Tokens are encrypted (AES, Fernet). The Mordomo reads only what is needed to triage and draft replies. Nothing is sent without your confirmation. You can disconnect anytime — everything is erased.",
        promises: [
          "Daily triage at 08:30 via WhatsApp",
          "Reply drafts in your tone — never sends without your approval",
          "Receipts in attachments flow directly into Memory",
          "Calendar invitations are created automatically",
          "Disconnecting erases all tokens immediately",
        ],
        triageTitle: "Inbox triage",
        triageBtn: "Triage now",
        triaging: "Triaging…",
        triageEmpty: "Nothing triaged yet. Tap «Triage now» and I'll take care.",
        draftBtn: "Draft a reply",
        drafting: "Drafting…",
        draftPlaceholder: "The Mordomo's draft appears here…",
        sendBtn: "Send",
        sending: "Sending…",
        archiveBtn: "Archive",
        archiving: "Archiving…",
        cancelBtn: "Cancel",
        sentLabel: "✓ Sent",
        archivedLabel: "Archived",
        briefingTitle: "Morning briefing",
        briefingPreview: "Preview briefing",
        briefingSend: "Send to WhatsApp",
        briefingSending: "Sending…",
        briefingSent: "Briefing sent to WhatsApp.",
        briefingEmpty: "Nothing new since last triage.",
        briefingNoWhatsapp: "To receive on WhatsApp, add your number in the profile.",
        wrapupTitle: "Day's wrap-up",
        wrapupPreview: "Preview wrap-up",
        wrapupSend: "Send to WhatsApp",
        wrapupSent: "Wrap-up sent to WhatsApp.",
        wrapupNoActivity: "No inbox activity today.",
      },
      memory: {
        title: "Memory",
        sub: "The Mordomo keeps. The Chefe forgets.",
        tabAll: "All",
        tabExpenses: "Expenses",
        tabAsk: "Ask",
        captureBtn: "+ Archive",
        captureModalTitle: "Archive a moment",
        captureModalSub: "Snap a photo, send a voice note, or type. I take care of the rest.",
        capturePhoto: "Photo",
        captureAudio: "Audio",
        captureText: "Text",
        captureTextPlaceholder: "A note, a handwritten receipt, a reminder…",
        captureSubmit: "Archive",
        capturing: "Archiving…",
        empty: "Nothing archived yet. Start with the first document.",
        searchPlaceholder: "Search the archive…",
        filterType: "Type",
        filterCategory: "Category",
        filterMonth: "Month",
        filterAll: "All",
        docTypes: {
          receipt: "Receipt",
          invoice: "Invoice",
          handwritten_note: "Note",
          message_screenshot: "Message",
          school_document: "School",
          medical_document: "Medical",
          id_document: "ID",
          other: "Other",
        },
        categories: {
          mercado: "Grocery",
          saude: "Health",
          educacao: "Education",
          casa: "Home",
          transportes: "Transport",
          lazer: "Leisure",
          vestuario: "Apparel",
          restauracao: "Dining",
          servicos: "Services",
          subscricoes: "Subscriptions",
          viagens: "Travel",
          outros: "Other",
        },
        expensesThisMonth: "This month",
        expensesPrevMonth: "Previous month",
        expensesByCategory: "By category",
        expensesTrend: "Last 6 months",
        expensesEmpty: "Once you archive receipts, the picture will appear.",
        recent: "Recent",
        askPlaceholder: "Mordomo, how much did I spend on paediatrics this year?",
        askBtn: "Ask",
        asking: "Consulting…",
        deleteBtn: "Delete",
        deleteConfirm: "Delete this memory?",
        capturedAt: "Document from",
        archivedAt: "Archived",
        sourceTypes: { image: "Photo", audio: "Audio", text: "Text" },
      },
      ingestTitle: "Ingest",
      ingestSub: "Paste an email, group chat, or upload a photograph. The Mordomo reads and proposes.",
      ingestTextLabel: "Text",
      ingestTextPlaceholder: "Paste email, screenshot or message here…",
      ingestImageLabel: "Image",
      ingestImageHint: "PNG or JPG. Posters, screenshots, photographed schedules.",
      ingestImagePasteHint: "You can also paste (Ctrl/Cmd+V) an image from the clipboard.",
      ingestImagePasted: "Pasted",
      openChat: "Open conversation",
      ingestAudioLabel: "Audio",
      ingestAudioHint: "Press to record or stop.",
      ingestRecord: "Record",
      ingestStop: "Stop",
      ingestProcess: "Process",
      ingestProcessing: "Reading…",
      ingestResult: "Result",
      ingestEvents: "events",
      ingestTasks: "tasks",
      ingestShopping: "shopping",
      ingestSeeProposals: "See proposals",
      proposalsTitle: "Awaiting your authorisation",
      proposalsSub: "Proposals extracted from your emails, photos and audio. Approve to add them to your domains.",
      proposalsEmpty: "No pending proposals.",
      proposalsApprove: "Approve",
      proposalsDecline: "Decline",
      proposalsSource: "Source",
      kindEvent: "Event",
      kindTask: "Task",
      kindShopping: "Shopping item",
      calendarTitle: "Calendar",
      calendarSub: "Week view. Conflicts detected automatically. Subscribable from Google, Apple, Outlook.",
      calendarToday: "Today",
      calendarPrev: "Previous week",
      calendarNext: "Next week",
      calendarAdd: "New event",
      calendarIcal: "Export iCal",
      calendarConflicts: "Conflicts",
      calendarNoEvents: "No events this week.",
      eventTitle: "Title",
      eventStart: "Start",
      eventEnd: "End",
      eventLocation: "Location",
      eventNotes: "Notes",
      eventCreate: "Create event",
      shoppingTitle: "Shopping",
      shoppingSub: "Lists and recipes. Recipes generate a list automatically.",
      shoppingNewList: "New list",
      shoppingListName: "List name",
      shoppingAddItem: "Add item",
      shoppingEmptyLists: "No lists. Create the first.",
      shoppingPending: "pending",
      recipesTitle: "Recipes",
      recipesNew: "New recipe",
      recipesName: "Name",
      recipesIngredients: "Ingredients (one per line)",
      recipesSteps: "Steps (optional)",
      recipesToShopping: "Send to shopping",
      recipesEmpty: "No recipes. Add the first.",
      familyTitle: "Family",
      familySub: "Context for the Chefe. Close and extended members. Not clients — only context.",
      familyNew: "Add member",
      familyName: "Name",
      familyRole: "Role",
      familyAge: "Age",
      familyNotes: "Notes",
      familyPhone: "WhatsApp (E.164, optional)",
      familyRoles: {
        spouse: "Spouse",
        child: "Child",
        parent: "Parent",
        in_law: "In-law",
        sibling: "Sibling",
        other: "Other",
      },
      familyEmpty: "No members registered.",
      appointments: {
        title: "Appointments",
        sub: "The family's medical appointment record. Private, reserved for the Mordomo — never bleeds into shared summaries.",
        loading: "Loading…",
        empty: "No appointments on the books yet.",
        activeHeader: "Scheduled",
        cancelledHeader: "Cancelled",
        includeInactive: "Show cancelled",
        whenLabel: "When",
        locationLabel: "Location",
        providerLabel: "Doctor",
        viaChatHint: "To book, change or cancel, talk to the Mordomo in the chat.",
      },
      medications: {
        title: "Medication",
        sub: "The family's medication record. Private, reserved for the Mordomo — never bleeds into shared summaries.",
        loading: "Loading…",
        empty: "No medications on record yet.",
        activeHeader: "In course",
        cancelledHeader: "Cancelled",
        includeInactive: "Show cancelled",
        timesLabel: "Times",
        weekdaysLabel: "Days",
        periodLabel: "Period",
        ongoing: "Ongoing",
        startsOn: "Starts",
        endsOn: "Ends",
        everyDay: "Every day",
        weekdayShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        viaChatHint: "To add, change or cancel, talk to the Mordomo in the chat.",
      },
      emergencyButton: "Emergency",
      emergencyTitle: "Escalation",
      emergencySub: "The Mordomo listens and mobilises immediately. Say only what's essential.",
      emergencyCategory: "Category",
      emergencyCategories: {
        medical: "Medical",
        school: "School",
        emotional: "Emotional",
        other: "Other",
      },
      emergencyDescription: "Description",
      emergencySend: "Request escalation",
      emergencySent: "Escalation recorded",
      voice: "Voice",
      voiceRecording: "Recording…",
      voiceProcessing: "Transcribing…",
    },
  },
};

export default dict;
